import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useSelector} from "react-redux";

const MetaOptionsCard = () => {
    const {product, dispatch, errors} = useNewProduct();
    const user = useSelector(state => state.user);
    const isAdmin = user?.isAdminType;

    // Handle adding new image field (trigger file upload)
    const handleNewField = () => {
        const inputElement = document.createElement("input");
        inputElement.type = "file";
        inputElement.multiple = true; // Allow multiple images
        inputElement.accept = "image/*";
        inputElement.onchange = (event) => handleImageChange(event);
        inputElement.click(); // Programmatically click to open file dialog
    };

    // Handle uploading multiple images
    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);

        const newImages = files.map((file) => ({
            type: "image",
            url: file, // Store file object
            alt: "",
            position: "",
        }));

        // Update product with new images
        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {
                ...product,
                product_visual_imagery: [
                    ...product.product_visual_imagery,
                    ...newImages,
                ],
            },
        });
    };

    const handleValueUpdate = (event, field, index) => {
        let changed = product.product_visual_imagery.map((item, position) => (
            {...item, [field]: position === index ? event.target.value : item[field]}
        ));

        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {...product, product_visual_imagery: changed},
        });
    };

    const handleMetaFieldRemoval = (index) => {
        dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {
                ...product,
                product_visual_imagery: product.product_visual_imagery.filter(
                    (item, numbering) => numbering !== index
                ),
            },
        });
    };

    const renderImage = (fileUrl) => {
        if (!fileUrl) return null;

        const isUrl = typeof fileUrl === "string";
        return isUrl ? fileUrl : URL.createObjectURL(fileUrl);
    };

    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Meta Options</h2>
                </div>
            </div>

            <div className="card-body pt-0">
                <div className="mb-10">
                    <label className="form-label">Images</label>
                    {product.product_visual_imagery.map(
                        (item, index) =>
                            item.type === "image" && (
                                <div key={index} className="d-flex align-items-center gap-3 mb-3">
                                    {/* Image Preview */}
                                    <div className="w-50">
                                        <img
                                            src={renderImage(item.url)}
                                            alt="Preview"
                                            style={{
                                                maxWidth: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "12px",
                                            }}
                                        />
                                    </div>
                                    {/* Description Field */}
                                    <div className="w-25">
                                        <label className="form-label">Description</label>
                                        <input
                                            type="text"
                                            value={item.alt}
                                            className="form-control"
                                            placeholder="Description"
                                            onChange={(event) => handleValueUpdate(event, "alt", index)}
                                        />
                                    </div>

                                    {/* Position Field */}
                                    {
                                        isAdmin && (
                                            <div className="w-25">
                                                <label className="form-label">Position</label>
                                                <input
                                                    type="number"
                                                    value={item.position}
                                                    className="form-control"
                                                    placeholder="Position"
                                                    onChange={(event) =>
                                                        handleValueUpdate(event, "position", index)
                                                    }
                                                />
                                            </div>
                                        )
                                    }

                                    {/* Delete Button */}
                                    <button
                                        type="button"
                                        onClick={() => handleMetaFieldRemoval(index)}
                                        className="btn btn-danger btn-hover-scale"
                                        style={{
                                            marginTop: "1.5rem",
                                        }}
                                    >
                                        Delete
                                    </button>

                                </div>
                            )
                    )}

                    <br/>
                    <button
                        onClick={handleNewField}
                        type="button"
                        className="btn btn-sm btn-light-primary mb-3"
                    >
            <span className="svg-icon svg-icon-2">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
              >
                <rect
                    opacity="0.5"
                    x="11"
                    y="18"
                    width="12"
                    height="2"
                    rx="1"
                    transform="rotate(-90 11 18)"
                    fill="black"
                />
                <rect
                    x="6"
                    y="11"
                    width="12"
                    height="2"
                    rx="1"
                    fill="black"
                />
              </svg>
            </span>
                        Add image
                    </button>
                    <div className="text-muted fs-7">Add product-related images.</div>
                </div>
                <div className="mb-10">
                    <label className="form-label">Videos</label>
                    {
                        product.product_visual_imagery.map((item, index) => item.type === "video" && (
                            <>
                                <div className="d-flex align-items-center justify-content-around gap-3 mb-3">
                                    <input key={index} type="text"
                                           className="form-control"
                                           name="meta_title"
                                           placeholder="URL"
                                           value={item.url}
                                           onChange={event => handleValueUpdate(event, 'url', index)}
                                    />
                                    <button
                                        type="button"
                                        onClick={event => handleMetaFieldRemoval(event, index)}
                                        className="btn btn-danger btn-hover-scale me-5"
                                    >
                                        -
                                    </button>
                                </div>

                                {
                                    errors.hasOwnProperty(`product_visual_imagery.${index}.url`) && (
                                        errors[`product_visual_imagery.${index}.url`].map((item, index) => (
                                            <div key={index} className="fs-7 mb-7 text-danger">{item}</div>
                                        ))
                                    )
                                }
                            </>
                        ))
                    }
                    <br/>
                    <button onClick={() => handleNewField("video")} type="button" data-repeater-create=""
                            className="btn btn-sm btn-light-primary mb-3">
                            <span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12"
                                          height="2" rx="1"
                                          transform="rotate(-90 11 18)"
                                          fill="black"/>
                                    <rect x="6" y="11" width="12" height="2"
                                          rx="1" fill="black"/>
                                </svg>
                            </span>
                        Add video
                    </button>

                    <div className="text-muted fs-7 mb-3">Add product related videos.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MetaOptionsCard;
